import { createAction } from '@reduxjs/toolkit';

import type { TransactionsTypes } from '@modules';
import api from '@modules/api';
import { CryptoCurrencyEnum } from '@modules/global/types';
import { createActions, createAsyncActions } from '@modules/helpers';

const actions = createActions('transactions', {
  resetTransactions: name => createAction(name),
  resetReferralList: name => createAction(name),
});

export const asyncActions = createAsyncActions('transactions', {
  getTransactions: (data: TransactionsTypes.GetTransactionsParams | void, thunkApi) => {
    const url = '/transactions';
    return api.get<TransactionsTypes.GetTransactionsResponse>(thunkApi, url, { params: data });
  },

  getReferral: (currency: CryptoCurrencyEnum | undefined, thunkApi) => {
    const url = '/referral';
    return api.get<TransactionsTypes.GetReferralResponse>(thunkApi, url, { params: { currency } });
  },

  getReferralTransactions: (data: TransactionsTypes.GetReferralTransactionsParams, thunkApi) => {
    const url = '/referral/transactions';
    return api.get<TransactionsTypes.GetReferralTransactionsResponse>(thunkApi, url, {
      params: data,
    });
  },
});

export default { ...actions, ...asyncActions };
